import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import AppLayout from "./AppLayout";
import ProtectedRoute from "./ProtectedRoute";

const Login = lazy(() => import("./pages/Login"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Product = lazy(() => import("./pages/Product"));
const Customer = lazy(() => import("./pages/Customer"));
const Supplier = lazy(() => import("./pages/Supplier"));
const Sale = lazy(() => import("./pages/Sale"));
const Purchase = lazy(() => import("./pages/Purchase"));
const Firm = lazy(() => import("./pages/Firm"));
const PrintSettings = lazy(() => import("./pages/PrintSettings"));
const PrintSale = lazy(() => import("./pages/PrintSale"));
const StockReport = lazy(() => import("./pages/StockReport"));
const SaleReport = lazy(() => import("./pages/SaleReport"));
const PurchaseReport = lazy(() => import("./pages/PurchaseReport"));

function RouteFallback() {
  return (
    <div className="route-loading" role="status">
      Loading page...
    </div>
  );
}

function ProtectedPage({ children }) {
  return (
    <ProtectedRoute>
      <Suspense fallback={<RouteFallback />}>{children}</Suspense>
    </ProtectedRoute>
  );
}

const ComingSoon = ({ title }) => {
  return (
    <AppLayout title={title} subtitle="Module under development">
      <div className="form-card">
        <div className="form-card-body">
          <h2>{title}</h2>
          <p style={{ marginTop: "8px", color: "#64748b" }}>
            This module will be added next.
          </p>
        </div>
      </div>
    </AppLayout>
  );
};

function App() {
  const comingSoonRoutes = [
    ["/master/roles", "Role Management"],
    ["/master/users", "User Management"],
    ["/accounts/supplier", "Supplier Master"],
  ];

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />

        <Route
          path="/login"
          element={
            <Suspense fallback={<RouteFallback />}>
              <Login />
            </Suspense>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedPage>
              <Dashboard />
            </ProtectedPage>
          }
        />

        <Route
          path="/master/firm"
          element={
            <ProtectedPage>
              <Firm />
            </ProtectedPage>
          }
        />

        <Route
          path="/master/print-settings"
          element={
            <ProtectedPage>
              <PrintSettings />
            </ProtectedPage>
          }
        />

        <Route
          path="/master/product"
          element={
            <ProtectedPage>
              <Product />
            </ProtectedPage>
          }
        />

        <Route
          path="/accounts/customer"
          element={
            <ProtectedPage>
              <Customer />
            </ProtectedPage>
          }
        />

        <Route
          path="/accounts/supplier"
          element={
            <ProtectedPage>
              <Supplier />
            </ProtectedPage>
          }
        />

        <Route
          path="/transaction/sale"
          element={
            <ProtectedPage>
              <Sale />
            </ProtectedPage>
          }
        />

        <Route
          path="/transaction/purchase"
          element={
            <ProtectedPage>
              <Purchase />
            </ProtectedPage>
          }
        />

        <Route
          path="/reports/stock"
          element={
            <ProtectedPage>
              <StockReport />
            </ProtectedPage>
          }
        />

        <Route
          path="/reports/sale"
          element={
            <ProtectedPage>
              <SaleReport />
            </ProtectedPage>
          }
        />

        <Route
          path="/reports/purchase"
          element={
            <ProtectedPage>
              <PurchaseReport />
            </ProtectedPage>
          }
        />

        <Route
          path="/print-sale/:id"
          element={
            <ProtectedPage>
              <PrintSale />
            </ProtectedPage>
          }
        />

        {comingSoonRoutes.map(([path, title]) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute>
                <ComingSoon title={title} />
              </ProtectedRoute>
            }
          />
        ))}

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
